/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Battery Low Status Icon component.
 */
export const MapBatteryStatusIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_23332_6414)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='#BDBDBD' />
        <path fillRule='evenodd' clipRule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2.00619 17.5203 6.47972 21.9938 12 22Z' fill='white' />
        <mask id='mask0_23332_6414' style={{maskType: 'luminance'}} maskUnits='userSpaceOnUse' x='8' y='5' width='8' height='14'>
          <path d='M15.9 5.00098H8V18.201H15.9V5.00098Z' fill='white' />
        </mask>
        <g mask='url(#mask0_23332_6414)'>
          <path d='M12.6 12.901H11.3V9.00098H12.6V12.901ZM12.6 15.601H11.3V14.301H12.6V15.601ZM15.1 6.30098H14V5.00098H10V6.30098H8.9C8.4 6.30098 8 6.70098 8 7.20098V17.301C8 17.801 8.4 18.201 8.9 18.201H15C15.5 18.201 15.9 17.801 15.9 17.301V7.20098C15.9 6.70098 15.5 6.30098 15.1 6.30098Z' fill={iconColor} />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_23332_6414'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapBatteryStatusIcon;
